import { globalStyle, style } from "@vanilla-extract/css";
import { calc } from "@vanilla-extract/css-utils";
import { vars } from "plos/src/styles";

export const prizesWrapper = style({
  display: "flex",
  flexDirection: "column",
  gap: vars.space.xs,
});

globalStyle(`${prizesWrapper} li`, {
  marginInlineStart: vars.space.m,
  listStyle: "disc",
});

globalStyle(`${prizesWrapper} h3`, {
  marginBottom: calc.negate(vars.space.xs),
});
